import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { Component, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Commands, Results } from '@local/client-contracts';
import { fromEvent, race, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  exportAs: 'dropdown',
})
export class DropdownComponent {
  @Input() model: Results.Dropdown;
  @Output() invoke = new EventEmitter<Commands.Command>();
  @ViewChild('dropdown') dropdown: TemplateRef<any>;

  private sub: Subscription;
  private overlayRef: OverlayRef | null;

  constructor(private overlay: Overlay) {}

  onInvoke(command: Commands.Command): void {
    this.invoke.emit(command);
  }

  open(elementRef: ElementRef, viewContainerRef: ViewContainerRef): void {
    this.close();
    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(elementRef)
      .withPositions([
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
        },
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close({ threshold: 0 }),
    });

    this.overlayRef.attach(
      new TemplatePortal(this.dropdown, viewContainerRef, {
        $implicit: this.model.items,
      })
    );
    requestAnimationFrame(() => {
      // HACK: this makes sure the close trigger is registered after the dropdown is displayed
      //       so the click that triggered the open won't close it.
      this.sub = race(
        fromEvent<MouseEvent>(document, 'click'),
        fromEvent<MouseEvent>(document, 'keydown'),
        fromEvent<WheelEvent>(window, 'wheel')
      )
        .pipe(take(1))
        .subscribe(() => this.close());
    });
  }

  close(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }

    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }
}
